import React, { useContext } from 'react';
import { Card, CardBody, Progress } from 'reactstrap';
import { ApiContext } from '../../contexts/ApiContext';
import { useWhatsappSession, getWhatsappStatusLabel, getWhatsappStatusColor } from '../../hooks/useWhatsappSession';

const progressValue = (status) => {
  if (status === 'CONNECTED') return 100;
  if (status === 'QR' || status === 'CONNECTING') return 50;
  return 10;
};

function WhatsappStatusBar({ compact = false }) {
  const { account } = useContext(ApiContext);
  const isWaba = account?.whatsappProvider === 'waba';
  const { session } = useWhatsappSession(account?.id);

  if (!account?.id) return null;

  const status = session?.status || 'DISCONNECTED';
  const color = getWhatsappStatusColor(status);
  const label = getWhatsappStatusLabel(status);
  const phone = session?.phoneNumber;

  if (compact) {
    return (
      <div className="d-flex align-items-center" style={{ gap: 8 }}>
        <i className={`tim-icons icon-chat-33 text-${color}`} />
        <span className="text-muted" style={{ fontSize: 13 }}>
          WhatsApp: <span className={`text-${color}`}>{label}</span>
          {phone ? ` (${phone})` : ''}
        </span>
      </div>
    );
  }

  return (
    <Card className="mb-3">
      <CardBody className="py-3">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div>
            <strong>WhatsApp{isWaba ? ' · Cloud API oficial' : ''}</strong>
            <div className="text-muted" style={{ fontSize: 13 }}>
              {label}
              {phone ? ` · ${phone}` : ''}
            </div>
          </div>
          <i className={`tim-icons icon-chat-33 text-${color}`} style={{ fontSize: 24 }} />
        </div>
        <Progress value={progressValue(status)} color={color} style={{ height: 6 }} />
      </CardBody>
    </Card>
  );
}

export default WhatsappStatusBar;
